var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 125,
    viewBox: "0 0 92 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8836_20415)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -90.8557,
    width: 182.288,
    height: 124.724,
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.88257,
    y: 54.3672,
    width: 33.5795,
    height: 31.9804,
    rx: 3.19804,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.88257,
    y: 91.1445,
    width: 51.1687,
    height: 23.9853,
    rx: 3.19804,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8484,
    y: 91.1445,
    width: 15.9902,
    height: 23.9853,
    rx: 3.19804,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2592,
    y: 54.3672,
    width: 33.5795,
    height: 31.9804,
    rx: 3.19804,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.88257,
    y: 9.59473,
    width: 71.956,
    height: 39.9756,
    rx: 3.19804,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0909 22.8778C36.1877 21.9226 36.8439 21.1954 37.7923 21.0457C39.0573 20.846 41.2806 20.6313 44.9934 20.6313C48.7062 20.6313 50.9295 20.846 52.1945 21.0457C53.1428 21.1954 53.7991 21.9226 53.8959 22.8778C53.9768 23.6759 54.056 24.8442 54.0883 26.4999C54.2547 26.7618 54.3509 27.0714 54.3509 27.4031C54.3509 27.7247 54.2606 28.0254 54.1035 28.2821C54.1002 30.3658 54.0281 31.8462 53.9436 32.8697C54.0901 32.9432 54.2313 33.0346 54.3647 33.1432C54.9896 33.6519 55.8983 34.436 57.1673 35.6236C57.1412 35.9745 57.1135 36.2804 57.086 36.5454C56.987 37.4975 56.3384 38.2282 55.3943 38.3862C54.0727 38.6072 51.7005 38.8517 47.6731 38.8517C43.6458 38.8517 41.2736 38.6072 39.952 38.3862C39.0078 38.2282 38.3592 37.4975 38.2603 36.5454C38.2273 36.2284 38.1943 35.853 38.1639 35.4121C38.2058 35.3724 38.2474 35.333 38.2888 35.294C38.109 35.2701 37.9438 35.246 37.7923 35.222C36.8439 35.0724 36.1877 34.3452 36.0909 33.39C35.9856 32.3512 35.8832 30.6852 35.8832 28.1339C35.8832 25.5825 35.9856 23.9165 36.0909 22.8778Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2575 25.0733C38.3571 24.1197 39.0092 23.3894 39.9552 23.2334C41.2776 23.0154 43.6491 22.7744 47.6727 22.7744C51.6963 22.7744 54.0678 23.0154 55.3902 23.2334C56.3362 23.3894 56.9883 24.1197 57.0879 25.0733C57.2031 26.1775 57.3188 27.989 57.3188 30.8128C57.3188 33.6366 57.2031 35.4482 57.0879 36.5524C56.9883 37.506 56.3362 38.2363 55.3902 38.3923C54.0678 38.6103 51.6963 38.8512 47.6727 38.8512C43.6491 38.8512 41.2776 38.6103 39.9552 38.3923C39.0092 38.2363 38.3571 37.506 38.2575 36.5524C38.1423 35.4482 38.0266 33.6366 38.0266 30.8128C38.0266 27.989 38.1423 26.1775 38.2575 25.0733ZM57.1671 35.6231C57.141 35.974 57.1134 36.2799 57.0858 36.5449C56.9869 37.497 56.3383 38.2277 55.3942 38.3856C54.0725 38.6067 51.7003 38.8512 47.673 38.8512C43.6456 38.8512 41.2734 38.6067 39.9518 38.3856C39.0077 38.2277 38.3591 37.497 38.2601 36.5449C38.2272 36.2279 38.1942 35.8525 38.1637 35.4115C40.3101 33.3786 41.8001 32.2457 42.7385 31.6257C43.5127 31.1143 44.4594 31.2006 45.1779 31.7855C45.9614 32.4233 47.1909 33.494 49.0173 35.2501C50.2959 34.1356 51.2523 33.4274 51.9251 32.9828C52.6993 32.4714 53.646 32.5578 54.3645 33.1427C54.9894 33.6514 55.8982 34.4355 57.1671 35.6231ZM54.3508 27.4026C54.3508 28.3443 53.5756 29.1077 52.6194 29.1077C51.6632 29.1077 50.8881 28.3443 50.8881 27.4026C50.8881 26.4609 51.6632 25.6975 52.6194 25.6975C53.5756 25.6975 54.3508 26.4609 54.3508 27.4026Z",
    fill: "#DEE2E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8836_20415"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.288452,
    width: 91.1442,
    height: 124.724,
    rx: 4.79707,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollages);
export default __webpack_public_path__ + "static/media/collages.fe005c801451b68d5a3cee999ac9e6c8.svg";
export { ForwardRef as ReactComponent };